export default [{
  path: '/',
  name: 'Home',
  component: () => import('@/views/home/Home'),
  meta: {
    metaInfo: {
      'title': '湖南联盛网络科技有限公司-白金岛官网|长沙麻将|跑得快|歪胡子|跑胡子|三打哈|拖拉机|湖南人的棋牌游戏',
      'keywords': '',
      'description': ''
    }
  }
}, {
  path: '/download',
  name: 'download',
  redirect: '/download/pc',
  component: () => import('@/views/download/Index'),
  meta: {
    metaInfo: {
      'title': '湖南联盛网络科技有限公司-白金岛游戏下载|白金岛游戏大厅下载|游戏下载|客户端下载--白金岛官方网站',
      'keywords': '白金岛游戏大厅免费下载，棋牌游戏下载，家乡话棋牌游戏，白金岛棋牌游戏、网上最好玩的家乡话家乡棋牌游戏，湖南人自己的游戏、休闲益智健康、画面漂亮、乐趣多多',
      'description': '白金岛游戏大厅免费下载、白金岛官网、白金岛游戏下载、家乡话棋牌游戏、棋牌游戏下载、家乡休闲棋牌游戏、方言棋牌游戏、休闲益智健康绿色'
    }
  },
  children: [{
    path: 'pc',
    name: 'DownloadPc',
    component: () => import('@/views/download/children/Pc'),
    meta: {
      metaInfo: {
        'title': '湖南联盛网络科技有限公司-白金岛游戏下载|白金岛游戏大厅下载|游戏下载|客户端下载--白金岛官方网站',
        'keywords': '白金岛游戏大厅免费下载，棋牌游戏下载，家乡话棋牌游戏，白金岛棋牌游戏、网上最好玩的家乡话家乡棋牌游戏，湖南人自己的游戏、休闲益智健康、画面漂亮、乐趣多多',
        'description': '白金岛游戏大厅免费下载、白金岛官网、白金岛游戏下载、家乡话棋牌游戏、棋牌游戏下载、家乡休闲棋牌游戏、方言棋牌游戏、休闲益智健康绿色'
      }
    }
  }, {
    path: 'mobile',
    name: 'DownloadMobile',
    component: () => import('@/views/download/children/Mobile'),
    meta: {
      metaInfo: {
        'title': '湖南联盛网络科技有限公司-白金岛游戏下载|白金岛游戏大厅下载|游戏下载|客户端下载--白金岛官方网站',
        'keywords': '白金岛游戏大厅免费下载，棋牌游戏下载，家乡话棋牌游戏，白金岛棋牌游戏、网上最好玩的家乡话家乡棋牌游戏，湖南人自己的游戏、休闲益智健康、画面漂亮、乐趣多多',
        'description': '白金岛游戏大厅免费下载、白金岛官网、白金岛游戏下载、家乡话棋牌游戏、棋牌游戏下载、家乡休闲棋牌游戏、方言棋牌游戏、休闲益智健康绿色'
      }
    }
  }]
}, {
  path: '/pay',
  name: 'pay',
  redirect: '/pay/wxpay',
  component: () => import('@/views/pay/Index'),
  meta: {
    metaInfo: {
      'title': '湖南联盛网络科技有限公司-充值中心 — 白金岛官方网站 — 最受欢迎的本土棋牌游戏平台',
      'keywords': '白金岛游戏大厅免费下载，棋牌游戏下载，家乡话棋牌游戏，白金岛棋牌游戏、网上最好玩的家乡话家乡棋牌游戏，湖南人自己的游戏、休闲益智健康、画面漂亮、乐趣多多',
      'description': '白金岛游戏大厅免费下载、白金岛官网、白金岛游戏下载、家乡话棋牌游戏、棋牌游戏下载、家乡休闲棋牌游戏、方言棋牌游戏、休闲益智健康绿色'
    }
  },
  children: [{
    path: 'wxpay',
    name: 'Wxpay',
    component: () => import('@/views/pay/Index'),
    meta: {
      metaInfo: {
        'title': '湖南联盛网络科技有限公司-白金岛官方网站 — 最受欢迎的本土棋牌游戏平台',
        'keywords': '白金岛游戏大厅免费下载，棋牌游戏下载，家乡话棋牌游戏，白金岛棋牌游戏、网上最好玩的家乡话家乡棋牌游戏，湖南人自己的游戏、休闲益智健康、画面漂亮、乐趣多多',
        'description': '白金岛游戏大厅免费下载、白金岛官网、白金岛游戏下载、家乡话棋牌游戏、棋牌游戏下载、家乡休闲棋牌游戏、方言棋牌游戏、休闲益智健康绿色'
      }
    }
  }, {
    path: 'alipay',
    name: 'Alipay',
    component: () => import('@/views/pay/Index'),
    meta: {
      metaInfo: {
        'title': '湖南联盛网络科技有限公司-白金岛官方网站 — 最受欢迎的本土棋牌游戏平台',
        'keywords': '白金岛游戏大厅免费下载，棋牌游戏下载，家乡话棋牌游戏，白金岛棋牌游戏、网上最好玩的家乡话家乡棋牌游戏，湖南人自己的游戏、休闲益智健康、画面漂亮、乐趣多多',
        'description': '白金岛游戏大厅免费下载、白金岛官网、白金岛游戏下载、家乡话棋牌游戏、棋牌游戏下载、家乡休闲棋牌游戏、方言棋牌游戏、休闲益智健康绿色'
      }
    }
  }]
}, {
  path: '/news',
  name: 'news',
  redirect: '/news/1',
  component: () => import('@/views/news/Index'),
  meta: {
    metaInfo: {
      'title': '湖南联盛网络科技有限公司-白金岛官方网站 — 最受欢迎的本土棋牌游戏平台',
      'keywords': '白金岛游戏大厅免费下载，棋牌游戏下载，家乡话棋牌游戏，白金岛棋牌游戏、网上最好玩的家乡话家乡棋牌游戏，湖南人自己的游戏、休闲益智健康、画面漂亮、乐趣多多',
      'description': '白金岛游戏大厅免费下载、白金岛官网、白金岛游戏下载、家乡话棋牌游戏、棋牌游戏下载、家乡休闲棋牌游戏、方言棋牌游戏、休闲益智健康绿色'
    }
  },
  children: [{
    path: '/news/:type(\\d+)',
    name: 'NewsCategory',
    component: () => import('@/views/news/children/Lists'),
    meta: {
      metaInfo: {
        'title': '湖南联盛网络科技有限公司-白金岛官方网站 — 最受欢迎的本土棋牌游戏平台',
        'keywords': '白金岛游戏大厅免费下载，棋牌游戏下载，家乡话棋牌游戏，白金岛棋牌游戏、网上最好玩的家乡话家乡棋牌游戏，湖南人自己的游戏、休闲益智健康、画面漂亮、乐趣多多',
        'description': '白金岛游戏大厅免费下载、白金岛官网、白金岛游戏下载、家乡话棋牌游戏、棋牌游戏下载、家乡休闲棋牌游戏、方言棋牌游戏、休闲益智健康绿色'
      }
    }
  }]
}, {
  path: '/news/detail/:newsId',
  name: 'NewsDetail',
  component: () => import('@/views/news/children/Detail'),
  meta: {
    metaInfo: {
      'title': '湖南联盛网络科技有限公司-白金岛官方网站 — 最受欢迎的本土棋牌游戏平台',
      'keywords': '白金岛游戏大厅免费下载，棋牌游戏下载，家乡话棋牌游戏，白金岛棋牌游戏、网上最好玩的家乡话家乡棋牌游戏，湖南人自己的游戏、休闲益智健康、画面漂亮、乐趣多多',
      'description': '白金岛游戏大厅免费下载、白金岛官网、白金岛游戏下载、家乡话棋牌游戏、棋牌游戏下载、家乡休闲棋牌游戏、方言棋牌游戏、休闲益智健康绿色'
    }
  }
}, {
  path: '/exchange',
  name: 'Exchange',
  redirect: '/exchange/goods_lists',
  component: () => import('@/views/exchange/Index'),
  meta: {
    metaInfo: {
      'title': '湖南联盛网络科技有限公司-白金岛官方网站 — 最受欢迎的本土棋牌游戏平台',
      'keywords': '白金岛游戏大厅免费下载，棋牌游戏下载，家乡话棋牌游戏，白金岛棋牌游戏、网上最好玩的家乡话家乡棋牌游戏，湖南人自己的游戏、休闲益智健康、画面漂亮、乐趣多多',
      'description': '白金岛游戏大厅免费下载、白金岛官网、白金岛游戏下载、家乡话棋牌游戏、棋牌游戏下载、家乡休闲棋牌游戏、方言棋牌游戏、休闲益智健康绿色'
    }
  },
  children: [
    {
      path: 'goods_lists',
      component: () => import('@/views/exchange/children/ExchangeGoodsLists'),
      meta: {
        metaInfo: {
          'title': '湖南联盛网络科技有限公司-白金岛官方网站 — 最受欢迎的本土棋牌游戏平台',
          'keywords': '白金岛游戏大厅免费下载，棋牌游戏下载，家乡话棋牌游戏，白金岛棋牌游戏、网上最好玩的家乡话家乡棋牌游戏，湖南人自己的游戏、休闲益智健康、画面漂亮、乐趣多多',
          'description': '白金岛游戏大厅免费下载、白金岛官网、白金岛游戏下载、家乡话棋牌游戏、棋牌游戏下载、家乡休闲棋牌游戏、方言棋牌游戏、休闲益智健康绿色'
        }
      }
    }, {
      path: 'log_lists',
      name: 'ExchangeLogs',
      component: () => import('@/views/exchange/children/ExchangeLogs'),
      meta: {
        metaInfo: {
          'title': '湖南联盛网络科技有限公司-白金岛官方网站 — 最受欢迎的本土棋牌游戏平台',
          'keywords': '白金岛游戏大厅免费下载，棋牌游戏下载，家乡话棋牌游戏，白金岛棋牌游戏、网上最好玩的家乡话家乡棋牌游戏，湖南人自己的游戏、休闲益智健康、画面漂亮、乐趣多多',
          'description': '白金岛游戏大厅免费下载、白金岛官网、白金岛游戏下载、家乡话棋牌游戏、棋牌游戏下载、家乡休闲棋牌游戏、方言棋牌游戏、休闲益智健康绿色'
        }
      }
    }, {
      path: 'intro',
      component: () => import('@/views/exchange/children/ExchangeIntro'),
      meta: {
        metaInfo: {
          'title': '湖南联盛网络科技有限公司-白金岛官方网站 — 最受欢迎的本土棋牌游戏平台',
          'keywords': '白金岛游戏大厅免费下载，棋牌游戏下载，家乡话棋牌游戏，白金岛棋牌游戏、网上最好玩的家乡话家乡棋牌游戏，湖南人自己的游戏、休闲益智健康、画面漂亮、乐趣多多',
          'description': '白金岛游戏大厅免费下载、白金岛官网、白金岛游戏下载、家乡话棋牌游戏、棋牌游戏下载、家乡休闲棋牌游戏、方言棋牌游戏、休闲益智健康绿色'
        }
      }
    }
  ]
}, {
  path: '/service_center',
  name: 'ServiceCenter',
  redirect: '/service_center/player_feedback',
  component: () => import('@/views/service_center/Index'),
  meta: {
    metaInfo: {
      'title': '湖南联盛网络科技有限公司-白金岛官方网站 — 最受欢迎的本土棋牌游戏平台',
      'keywords': '白金岛游戏大厅免费下载，棋牌游戏下载，家乡话棋牌游戏，白金岛棋牌游戏、网上最好玩的家乡话家乡棋牌游戏，湖南人自己的游戏、休闲益智健康、画面漂亮、乐趣多多',
      'description': '白金岛游戏大厅免费下载、白金岛官网、白金岛游戏下载、家乡话棋牌游戏、棋牌游戏下载、家乡休闲棋牌游戏、方言棋牌游戏、休闲益智健康绿色'
    }
  },
  children: [
    {
      path: 'contact',
      component: () => import('@/views/service_center/children/Contact'),
      meta: {
        metaInfo: {
          'title': '湖南联盛网络科技有限公司-白金岛官方网站 — 最受欢迎的本土棋牌游戏平台',
          'keywords': '白金岛游戏大厅免费下载，棋牌游戏下载，家乡话棋牌游戏，白金岛棋牌游戏、网上最好玩的家乡话家乡棋牌游戏，湖南人自己的游戏、休闲益智健康、画面漂亮、乐趣多多',
          'description': '白金岛游戏大厅免费下载、白金岛官网、白金岛游戏下载、家乡话棋牌游戏、棋牌游戏下载、家乡休闲棋牌游戏、方言棋牌游戏、休闲益智健康绿色'
        }
      }
    }, {
      path: 'statement',
      component: () => import('@/views/service_center/children/statement'),
      meta: {
        metaInfo: {
          'title': '湖南联盛网络科技有限公司-白金岛官方网站 — 最受欢迎的本土棋牌游戏平台',
          'keywords': '白金岛游戏大厅免费下载，棋牌游戏下载，家乡话棋牌游戏，白金岛棋牌游戏、网上最好玩的家乡话家乡棋牌游戏，湖南人自己的游戏、休闲益智健康、画面漂亮、乐趣多多',
          'description': '白金岛游戏大厅免费下载、白金岛官网、白金岛游戏下载、家乡话棋牌游戏、棋牌游戏下载、家乡休闲棋牌游戏、方言棋牌游戏、休闲益智健康绿色'
        }
      }
    }, {
      path: 'player_feedback',
      component: () => import('@/views/service_center/children/PlayerFeedback'),
      meta: {
        metaInfo: {
          'title': '湖南联盛网络科技有限公司-白金岛官方网站 — 最受欢迎的本土棋牌游戏平台',
          'keywords': '白金岛游戏大厅免费下载，棋牌游戏下载，家乡话棋牌游戏，白金岛棋牌游戏、网上最好玩的家乡话家乡棋牌游戏，湖南人自己的游戏、休闲益智健康、画面漂亮、乐趣多多',
          'description': '白金岛游戏大厅免费下载、白金岛官网、白金岛游戏下载、家乡话棋牌游戏、棋牌游戏下载、家乡休闲棋牌游戏、方言棋牌游戏、休闲益智健康绿色'
        }
      }
    }, {
      path: 'punish',
      component: () => import('@/views/service_center/children/Punish'),
      meta: {
        metaInfo: {
          'title': '湖南联盛网络科技有限公司-白金岛官方网站 — 最受欢迎的本土棋牌游戏平台',
          'keywords': '白金岛游戏大厅免费下载，棋牌游戏下载，家乡话棋牌游戏，白金岛棋牌游戏、网上最好玩的家乡话家乡棋牌游戏，湖南人自己的游戏、休闲益智健康、画面漂亮、乐趣多多',
          'description': '白金岛游戏大厅免费下载、白金岛官网、白金岛游戏下载、家乡话棋牌游戏、棋牌游戏下载、家乡休闲棋牌游戏、方言棋牌游戏、休闲益智健康绿色'
        }
      }
    }
  ]
}]



// WEBPACK FOOTER //
// ./src/router/routers.js